// Rule Forms.
import NotFound from "@app/modules/RuleSets/components/RuleForms/NotFound";
import ReturningCustom from "@app/modules/RuleSets/components/RuleForms/ReturningCustom";
import CommonReferrers from "@app/modules/RuleSets/components/RuleForms/CommonReferrers";
import CustomReferrers from "@app/modules/RuleSets/components/RuleForms/CustomReferrers";
import DateTime from "@app/modules/RuleSets/components/RuleForms/DateTime";
import PageReferrers from "@app/modules/RuleSets/components/RuleForms/PageReferrers";
import DynamicLink from "@app/modules/RuleSets/components/RuleForms/DynamicLink";
import VisitedPages from "@app/modules/RuleSets/components/RuleForms/VisitedPages";
import SubmittedGravityForms from "@app/modules/RuleSets/components/RuleForms/SubmittedGravityForms";
import DesktopDevice from "@app/modules/RuleSets/components/RuleForms/DesktopDevice";
import MobileDevice from "@app/modules/RuleSets/components/RuleForms/MobileDevice";
import TabletDevice from "@app/modules/RuleSets/components/RuleForms/TabletDevice";
import Android from "@app/modules/RuleSets/components/RuleForms/Android";
import GuestUser from "@app/modules/RuleSets/components/RuleForms/GuestUser";
import iOS from "@app/modules/RuleSets/components/RuleForms/iOS";
import Linux from "@app/modules/RuleSets/components/RuleForms/Linux";
import LoggedIn from "@app/modules/RuleSets/components/RuleForms/LoggedIn";
import macOS from "@app/modules/RuleSets/components/RuleForms/macOS";
import NewUser from "@app/modules/RuleSets/components/RuleForms/NewUser";
import Returning2 from "@app/modules/RuleSets/components/RuleForms/Returning2";
import Returning3 from "@app/modules/RuleSets/components/RuleForms/Returning3";
import Windows from "@app/modules/RuleSets/components/RuleForms/Windows";

export const rulesForms = {
	Android,
	CommonReferrers,
	CustomReferrers,
	DateTime,
	DesktopDevice,
	DynamicLink,
	GuestUser,
	iOS,
	Linux,
	LoggedIn,
	macOS,
	MobileDevice,
	NewUser,
	NotFound,
	PageReferrers,
	Returning2,
	Returning3,
	ReturningCustom,
	SubmittedGravityForms,
	TabletDevice,
	VisitedPages,
	Windows,
};
